import { PriceSummaryRow } from '@ps-design-system/components/PriceSummary';
import { Text } from '@ps-design-system/components/Text';
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger
} from '@ps-design-system/components/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { useCheckoutContext } from '../../CheckoutContextProvider';
import { AddOnsPriceSummary } from '../AddOnsPriceSummary/AddOnsPriceSummary';

export const AddOnsLineItem = ({
  currency,
  SSOid,
  tooltipAlign = 'center'
}) => {
  const { quote } = useCheckoutContext();
  const { addOnsContracts, masterContract } = quote;

  const addOnsTotal = masterContract?.calculations?.add_ons_guest_with_tax || 0;

  const [showTooltip, setShowTooltip] = React.useState(false);

  return (
    <PriceSummaryRow
      testId="add-ons-line-item"
      name={(
        <Tooltip
          rootProps={{
            delayDuration: 0,
            open: showTooltip,
            onOpenChange: setShowTooltip
          }}
        >
          <TooltipTrigger
            onClick={(e) => {
              e.preventDefault();
              setShowTooltip((prev) => !prev);
            }}
          >
            <Text style={{ textDecoration: 'underline' }}>
              <FormattedMessage
                id="price_summary.add_ons"
                defaultMessage="Add-ons"
              />
            </Text>
          </TooltipTrigger>
          <TooltipContent style={{ padding: '0' }} align={tooltipAlign}>
            <AddOnsPriceSummary
              addOnsContracts={addOnsContracts}
              addOnsTotal={addOnsTotal}
              addOnsSalesTax={
                masterContract?.calculations?.guest?.us_sales_tax_add_ons || 0
              }
              currency={currency}
              SSOid={SSOid}
              onClose={() => setShowTooltip(false)}
            />
            <TooltipArrow className="tw-fill-base-white" />
          </TooltipContent>
        </Tooltip>
      )}
      value={(
        <FormattedNumber
          value={addOnsTotal}
          style="currency"
          currency={currency}
        />
      )}
    />
  );
};

AddOnsLineItem.displayName = 'AddOnsLineItem';
AddOnsLineItem.propTypes = {
  addOnsContracts: PropTypes.array,
  currency: PropTypes.string,
  SSOid: PropTypes.string,
  tooltipAlign: PropTypes.string
};
